// Fetch Sections (Types)
export const FETCH_SECTIONS = "FETCH_SECTIONS"
export const FETCH_SECTIONS_SUCCESS = "FETCH_SECTIONS_SUCCESS"
export const FETCH_SECTIONS_FAIL = "FETCH_SECTIONS_FAIL"

// Fetch Section Tasks
export const FETCH_SECTION_TASKS = "FETCH_SECTION_TASKS"
export const FETCH_SECTION_TASKS_SUCCESS = "FETCH_SECTION_TASKS_SUCCESS"
export const FETCH_SECTION_TASKS_FAIL = "FETCH_SECTION_TASKS_FAIL"

// Update Task Status
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS"
export const UPDATE_TASK_STATUS_SUCCESS = "UPDATE_TASK_STATUS_SUCCESS"
export const UPDATE_TASK_STATUS_FAIL = "UPDATE_TASK_STATUS_FAIL"

// Clear cache
export const CLEAR_SECTIONS_CACHE = "CLEAR_SECTIONS_CACHE"

// Set active section
export const SET_ACTIVE_SECTION = "SET_ACTIVE_SECTION"
